<template>
  <div class="news">
    <div class="label">
      <h1>物联网发展</h1>
      <h5>History of Internet of Things</h5>
    </div>
    <div class="news-info">
      <el-row :gutter="16">
        <el-col :span="6">
          <img src="@/svg/new_6.jpeg" class="img-info" />
        </el-col>
        <el-col :span="18">
          5G时代即将到来，物联网也将得到空前的发展，我们不妨来看看物联网的发展历程。
          物联网的发展史最早可以追溯到比尔盖茨于1995年出版的《未来之路》。在此书中，比尔盖茨已经多次提到“物物互联”的设想。但是由于当时网络技术与传感器应用水平的限制，比尔盖茨朦胧的“物联网”理念没有引起重视。
          到了1998年，美国麻省理工学院的研究人员成功地完成了产品电子代码研究的基础上，提出利用射频标签，无线网络和互联网，构建物-物互联的物联网的概念与解决方案。
          物联网概念真正地引起各国政府与产业界的重视是在2005年国际电信联盟发布的互联网研究报告《物联网》之后，作为电信行业最有影响力的组织之一，我们可以看看它提出物联网概念的发展过程：
        </el-col>
        <el-col :span="6">
          <img src="@/svg/new_two.jpeg" class="img-info" />
        </el-col>
        <el-col :span="18">
          <p>物联网，被视为继互联网之后的又一次信息技术革命浪潮。物联网所带来的产业价值将比互联网大30倍，物联网将成为下一个万亿元级别的信息产业业务。</p>
        </el-col>
        <el-col :span="6">
          <img src="@/svg/new_3.jpeg" class="img-info" />
        </el-col>
        <el-col :span="18">
          <p>{{ newsOne }}</p>
        </el-col>
        <el-col :span="6">
          <img src="@/svg/new_4.jpeg" class="img-info" />
        </el-col>
        <el-col :span="18">
          <span>（1）在1997年，它发布了《挑战网络：电信与互联网》的报告。报告论述了互联网的发展对电信业的挑战，同时指出互联网给电信业带来了重大的发展机遇</span>
          <p>（2）在2002年，它发布了第四个研究报告《移动互联网时代》。该报告讨论了移动互联网发展的背景，技术与市场需求，以及手机上网与移动互联网服务。并且指出移动互联网的发展将带领我们进入一个移动的信息社会。</p>
        </el-col>
        <el-col :span="6">
          <img src="@/svg/new_5.jpeg" class="img-info" />
        </el-col>
        <el-col :span="18">
          <p>（3）在2003年，它发布了《宽带的诞生》。该报告讨论了计算机、通信和广播电视网络的三网融合问题，以及宽带网发展与未来新的应用，描述了宽带技术对未来信息社会的影响。</p>
          <p>（4）它在2004年发布了第6个研究报告《便携式互联网》，讨论了移动互联网技术、市场发展趋势，未来移动互联网技术的发展。</p>
          <p>
            （5）在2005年正式发布了研究报告《物联网》。报告描述了世界上的万事万物，只要嵌入一个微型的传感器芯片，通过互联网就能够实现物与物的信息交互，从而形成一个无所不在的“物联网”。
            从几份报告中，我们可以看到物联网发展必然性。相信在不久的将来，物联网将在医院，交通，学校等各行业得到广泛的运用，从而方便人们的生活。
          </p>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      newsOne: `  所有的互联网公司和企业都收集了大量的用户数据。当像"成千上万的人和成千上万的面孔"和"个性化的推荐"这样的词成为互联网公司技术实力的代名词时，这也意味着我们每个人都在这些互联网公司的监视下"裸奔"。

在这方面，不同的立法及规管机构将会引入更严格的使用者资料保护规则，而使用者的敏感资料可能会随时间受到更加严格的规管。

2.更安全的保护措施

随着物联网设备和基础设施价格的下降，物联网设备的应用越来越普及，这也意味着企业需要更加重视物联网的安全性。`
    }
  }
}
</script>
<style lang="scss" scope>
.news {
  padding-top: 30px;
  .label {
    text-align: center;
    h1 {
      color: #309ddc;
    }
    h5 {
      color: #309ddc;
    }
  }
  .news-info {
    padding: 40px 0 60px 0;
    margin: 0 auto;
    width: 70%;
    // text-align: center;
    .img-info {
      width: 300px;
      height: 200px;
    }
    .el-row .el-col-18 {
      text-indent: 0.5cm;
      height: 210px;
      font-size: 14px;
    }
  }
}
</style>
